import { DATE_FORMAT, JP_DATE_FORMAT, localeMap } from 'app/modules/Constants';
import { format, Locale } from "date-fns";

export function formattedDateString({ date, lng }: { date: Date; lng: string }) {
	const dateDisplayFormat = lng === 'jp' ? JP_DATE_FORMAT : DATE_FORMAT;
	const isKorean = lng === 'ko';
	const isSwedish = lng === 'sv';
	const isRussian = lng === 'ru';
	let formattedDate = format(date, dateDisplayFormat, { locale: localeMap[lng] });
	if (isRussian) {
		formattedDate = formattedDate.slice(0, 2) + formattedDate.slice(3);
	}
	if (isKorean) {
		formattedDate += '일';
	}

	let renderText: string | React.ReactNode = (
		<span style={{ textTransform: 'capitalize' }}>{formattedDate}</span>
	);

	if (isSwedish) {
		// Capitalize day, lowercase month
		renderText = formattedDate.replace(
			/(\D+),\s(\D+)/,
			(_, day, month) => `${day.charAt(0).toUpperCase() + day.slice(1)}, ${month.toLowerCase()}`
		);
	}

	return { ariaLabelString: formattedDate, renderText };
}
/**
 * Formats a date string with proper weekday abbreviations for different languages
 * For Russian, uses 2-letter weekday abbreviations instead of the default 3-letter ones
 * @param date - Date
 * @param locale - Locale object
 * @returns Formatted date string with weekday, day and month
 */
export function getFormattedWeekDate(date: Date, locale?: Locale) {
	if (locale?.code === 'ru') {
		// Russian 2-letter weekday abbreviations
		const russianWeekdays = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']
		const weekday = russianWeekdays[date.getDay()]
		return weekday
	} else {
		// For other languages, use the standard format
		return format(date, 'EEE', { locale })
	}
}
